import React from "react";
import { Constants } from "src/constant";
import { useFaqStore } from "src/store/faqStore";

export const FaqLoadError: React.FC = () => {
  const load = useFaqStore((s) => s.load);

  return (
    <div className="rounded-[1.75rem] border-4 border-dashed border-white/25 bg-white/5 p-10 text-center">
      <p className="text-lg font-extrabold text-white/90">
        Couldn&apos;t load FAQ.
      </p>
      <p className="mt-2 font-bold text-white/60">
        {Constants.NETWORK_ERROR_DESCRIPTION}
      </p>
      <button
        type="button"
        onClick={() => void load()}
        className="mt-6 inline-flex min-h-[48px] min-w-[8rem] items-center justify-center rounded-2xl border-2 border-[#E5E5E5] bg-white px-6 text-sm font-extrabold text-[#3C3C3C] shadow-[0_4px_0_#D0D0D0] active:translate-y-0.5"
      >
        Retry
      </button>
    </div>
  );
};
